module.exports = __webpack_public_path__ + "img/header_bg2.08f5a4fe.png";